module.exports = __webpack_public_path__ + "img/ksiega_znaku.1e56454a.jpg";